/* Auto Generated */

export enum ExpertDateAvailability {
	available,
	onRequest,
	unavailable,
}
